import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureInjector } from './services/feature-injector/feature-injector.service';

@NgModule({
  imports: [CommonModule],
})
export class LibFeatureDecisionModule {
  constructor(_injector: FeatureInjector) {
    /* Vide pour forcer l'initialisation du FeatureInjector */
  }
}
